import { useNotify, useRefresh, useUnselectAll } from "react-admin";

import { AppResource } from "../types/resource.types";

const useOnUpdateRecord = (resource: AppResource, successMessage: string, errorMessage: string) => {
  const refresh = useRefresh();
  const notify = useNotify();
  const unselectAll = useUnselectAll();

  return async (recordUpdateFn: () => Promise<void>) => {
    try {
      await recordUpdateFn();
      notify(successMessage, "success");
      unselectAll(resource);
      refresh();
    } catch (ex: any) {
      console.log(ex.message);
      notify(errorMessage, "error");
    }
  };
};

export default useOnUpdateRecord;
